import { addNode } from "~/nodes/definitions/add";
import {
  addFunctionsNode,
  multiplyFunctionsNode,
} from "~/nodes/definitions/functionOps";
import { animateNode } from "~/nodes/definitions/animate";
import { audioNode } from "~/nodes/definitions/audio";
import { colorPickerNode } from "~/nodes/definitions/colorPicker";
import { cubeNode } from "~/nodes/definitions/cube";
import { customNode } from "~/nodes/definitions/custom";
import { extrusionStyleNode } from "~/nodes/definitions/extrusionStyle";
import { indexColorNode } from "~/nodes/definitions/indexColor";
import { mathNode } from "~/nodes/definitions/math";
import { numberNode } from "~/nodes/definitions/number";
import { outputNode } from "~/nodes/definitions/output";
import { pointsStyleNode } from "~/nodes/definitions/pointsStyle";
import { shaderStyleNode } from "~/nodes/definitions/shaderStyle";
import { solidColorNode } from "~/nodes/definitions/solidColor";
import { sphereNode } from "~/nodes/definitions/sphere";
import { transformNode } from "~/nodes/definitions/transform";
import type { NodeDefinition } from "~/nodes/types";

/** Every node the editor can create. Order drives the "add node" menu. */
export const NODE_DEFINITIONS: NodeDefinition[] = [
  numberNode,
  animateNode,
  audioNode,
  addNode,
  mathNode,
  sphereNode,
  cubeNode,
  customNode,
  addFunctionsNode,
  multiplyFunctionsNode,
  colorPickerNode,
  solidColorNode,
  indexColorNode,
  pointsStyleNode,
  extrusionStyleNode,
  shaderStyleNode,
  transformNode,
  outputNode,
];

const byType = new Map(
  NODE_DEFINITIONS.map((definition) => [definition.type, definition]),
);

export function getDefinition(
  type: string | undefined,
): NodeDefinition | undefined {
  return type === undefined ? undefined : byType.get(type);
}

/** Definitions grouped by category, for the context menu. */
export const NODE_CATEGORIES: {
  category: string;
  definitions: NodeDefinition[];
}[] = (() => {
  const groups = new Map<string, NodeDefinition[]>();

  for (const definition of NODE_DEFINITIONS) {
    groups.set(definition.category, [
      ...(groups.get(definition.category) ?? []),
      definition,
    ]);
  }

  return [...groups].map(([category, definitions]) => ({
    category,
    definitions,
  }));
})();
